import { render, staticRenderFns } from "./SavedDashboardList.vue?vue&type=template&id=3d42f9a2"
import script from "./SavedDashboardList.vue?vue&type=script&lang=js"
export * from "./SavedDashboardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports